const META_BASE = '/metadata';
export const ApiRoutes = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  S3_URL: process.env.S3_BUCKET_URL,
  USER_LOGIN: '/auth/login',
  REGISTER_USER: 'auth/register',
  SEND_VERIFY_EMAIL: 'auth/send-otp',
  VERIFY_OTP: 'auth/verify-otp',
  COMPANY_DETAILS: '/company',
  COMPANY_ADDRESS: '/address',
  SEND_FORGOT_PASS_MAIL: 'auth/forgot-password',
  MOCK_PAYMENT: '/plan/payment',
  SET_NEW_PASS: '/auth/password',
  FETCH_BRANDS: '/brand',
  FETCH_SINGLE_BRAND: '/brand/:id',
  DELETE_BRAND: '/brand/:id',
  CREATE_BRAND: '/brand/',
  UPDATE_BRAND: '/brand/:id',
  PARENT_ORGANIZATION: '/organizations/parent',
  CREATE_PRODUCT_STAGE_1: '/activity-mapping/product/raw-material/:id',
  META_INGREDIENTS_STAGE_1: '/activity-mapping/ingredient',
  CREATE_PRODUCT_STAGE_2: '/activity-mapping/product/transportation/:id',
  META_INGREDIENTS_ORIGIN: '/activity-mapping/region',
  META_ACTIVITY: '/activity-mapping/activity',
  META_PACKAGING_STAGE_1: '/activity-mapping/packaging',
  META_REGION_STAGE_1: '/region',
  FETCH_STAGE_1_LIST: '/activity-mapping/product/raw-material/:id',
  FETCH_STAGE_2_LIST: '/activity-mapping/product/transportation/:id',
  FETCH_STAGE_4_LIST: '/activity-mapping/product/distribution/:id',
  FETCH_SUPPLIERS: '/supplier',
  CREATE_SUPPLIER: '/supplier',
  DELETE_SUPPLIER: '/supplier/:id',
  UPDATE_SUPPLIER: '/supplier/:id',
  FETCH_PROCESSING_FACILITY: '/processing-facility',
  CREATE_PROCESSING_FACILITY: '/processing-facility',
  DELETE_PROCESSING_FACILITY: '/processing-facility/:id',
  UPDATE_PROCESSING_FACILITY: '/processing-facility/:id',
  PRODUCT_DISTRIBUTION: '/activity-mapping/product/distribution/:id',

  CREATE_PRODUCT: '/product',
  PRODUCT_IMAGE: '/image/product/:id',
  FETCH_PRODUCT_BY_ID: '/product/:id',
  FETCH_STAGE1_EMISSIONS: '/emission/stage1/:id',
  FETCH_STAGE2_EMISSIONS: '/emission/stage2/:id',
  FETCH_STAGE1_AND_STAGE2: '/emission/stage/:id',
  VIEW_REPORT: '/image/product/:id/product-approval-report',
  FETCH_STAGE3_EMISSIONS: '/emission/stage3/:id',
  FETCH_STAGE4_EMISSIONS: '/emission/stage4/:id',
  FETCH_DQR: '/dashboard/:id/product-dashboard-dqr-metric',
  TOTAL_EMISSION_CHECK: '/emission/stage/check',
  FETCH_PRODUCTS: '/product',
  DELETE_PRODUCT: '/product/:id',
  EDIT_STAGE1: '/activity-mapping/product/raw-material/:id',
  EDIT_STAGE2: '/activity-mapping/product/transportation/:id',
  EDIT_STAGE4: '/activity-mapping/product/distribution/:id',
  UPDATE_PRODUCT_STATUS: '/product/status/:id',
  DUPLICATE_PRODUCT: 'product/:id/duplicate',

  FETCH_EMISSION_ALLPRODUCTS: '/dashboard/company-dashboard-allproduct-co2e',
  FETCH_PRODUCT_EMISSION:
    '/dashboard/company-dashboard-product-carbon-footprint',
  FETCH_PRODUCT_EMISSION_ANNUAL:
    '/dashboard/company-dashboard-annual-production-co2e',
  FETCH_GOAL_ALLPRODUCTS: '/dashboard/getgoal-co2e',
  CREATE_GOAL_ALLPRODUCTS: '/dashboard/setgoal-co2e',
  FETCH_EMISSION_EACH_STAGE: '/dashboard/:id/product-dashboard-each-co2e',
  FETCH_EMISSION_ANNUAL_PRODUCTION:
    '/dashboard/:id/product-dashboard-total-co2e',
  DOWNLOAD_CSV_FOR_EACH_LIFE_CYCLE:
    '/dashboard/:productId/product-dashboard-each-co2e/download',

  FETCH_COMPANY: '/user/company',
  COMPANY_IMAGE: '/image/company',
  FETCH_ACCOUNTS: '/user',
  ADD_USER: '/user',
  ROLES: '/user/roles',
  UPDATE_USER: '/user/:id',
  DELETE_USER: '/user/:id',
  SCOPE_CALCULATOR: 'processing-facility/scope_calculator',
  FETCH_GOAL: '/dashboard/getgoal-co2e',
  SET_GOAL: '/dashboard/setgoal-co2e',
  UPDATE_GOAL: '/dashboard/setgoal-co2e',
  STRIPE_PAYMENT: '/plan/payment-link',
  STRIPE_PAYMENT_UPDATE: '/plan/payment-update',
  FETCH_META_DATA: '/metadata',
  MATERIAL_REQUEST: '/material-request',
  HELPDESK: '/helpdesk',
  CHECK_EMAIL_EXISTS: '/auth/verify-email',
  GET_PLAN_DETAILS: '/plan/my-plan',

  IN_APP_NOTIFICATIONS: '/notification',
  IN_APP_NOTIFICATIONS_COUNT: '/notification/count',
  IN_APP_NOTIFICATIONS_SPECIFIC: '/notification/:id',

  GET_DEMO_VIDEO_WATCH_STATUS: '/user/demo-video/status',
  GET_DEMO_VIDEO_LINK: '/user/demo-video',
  DOWNLOAD: '/download',
  DOWNLOAD_MAP_CSV: '/emission/:id/download',

  CREATE_ORGANISATION: '/organizations',
  CREATE_FIRST_LOCATION: '/locations',
  META_SIZE_ORG: `${META_BASE}`,
  META_SECTOR: `${META_BASE}/company-types/:id/sectors`,
  META_COMPANY_TYPES: `${META_BASE}/company-types`,

  //ADE
  GET_LOCATION: '/locations/:locationId',
  LOCATION_DETAILS: '/locations/:location_id/activity-data-entries/:year',
  CREATE_SCOPE:
    '/locations/:location_id/activity-data-entries/:year/scope-categories/:scope_category',
  SCOPE_TEMPLATE:
    '/locations/:locationId/activity-data-entries/:year/scope-categories/:scopeCategory/templates',
  PRODUCTION_DATA:
    '/locations/:location_id/activity-data-entries/:year/production-data',

  //OrganisationMaps
  ORGANISATION_MAP: '/organization-maps',
  ORGANISATION_MAP_SPECIFIC: '/organization-maps/:id',
  ORGANIZATION_SPECIFIC: '/organizations/:id',
  ORGANIZATION_SPECIFIC_VALIDATION: '/organizations/:id/deactivate',
  EMISSION_SCOPE: '/dashboard/get-emission-by-scope',
  EMISSION_SOURCE: 'dashboard/get-emission-by-source',
  GET_ORGANIZATION_REVENUE: '/dashboard/get-organization-revenue',
  GET_LOCATION_REVENUE: '/dashboard/get-location-revenue',
  GET_LOCATIONS_ORG: '/organizations/:organisationId/child-locations',
  YOY_EMISSIONS: '/dashboard/get-yoy-emissions',
  YOY_PROD_EMISSION: '/dashboard/product/:productId/get-yoy-emission',
  INFO_GRAPHICS: '/dashboard/get-infographics',
  EMISSION_BY_LOCATION: '/dashboard/get-location-organization-emissions',
  CHILD_PRODUCTS: '/metadata/products/get-child-products',

  CREATE_PRODUCT_FIELDS_META: '/metadata/lock-product-fields',
  PRODUCTS_META: '/metadata/products',
  //SIBLING PRODUCTS
  FETCH_PRODUCT_SIBLING: '/metadata/products/:productId/siblings',
  PRODUCTS_LIST: '/metadata/products/statuses',

  //SBTi
  TARGET: '/sbti-target',
  TARGET_COVERAGE_META: '/metadata/sbti-target/target-coverage',
  TARGET_YEAR_META: '/metadata/sbti-target/target-year',
  UPDATE_TARGET: '/sbti-target/:targetId',
  DUPLICATE_TARGET_NAME: '/sbti-target/verify-target-name',
  DWLD_SBTI_CSV: '/sbti-target/:sbtiTargetId/yoy-emission',
  GET_PARENT_ORGANIZATION: '/organizations/baseline-year-parent',
  SCOPE_CATEGORY:
    '/locations/:locationId/activity-data-entries/:year/scope-categories/scope3/categories/:category',
  SCOPE_3_CATEGORY_TEMPLATE:
    '/locations/:locationId/activity-data-entries/:year/scope-categories/scope3/categories/:category/templates',

  //Scope Three
  CATEGORY_LISTING:
    '/locations/:locationId/activity-data-entries/:year/scope-categories/scope3/status',
  GET_CATEGORY_ONE:
    '/locations/:locationId/activity-data-entries/:year/scope-categories/scope3/categories/:category',
  META_OTHER: '/activity-mapping/scope3-category1',

  //Commodity List
  COMMODITY_LIST: '/commodities',
  DELETE_COMMODITY: '/commodities/:commodityId',

  //Farmbox
  CREATE_COMMADITY: '/commodities',
  COMMODITY_IMAGE: '/image/commodities/:id',
  LIVE_STOCK_COMMODITY_IMAGE: 'image/commodities/livestock/:id',

  //Commodity Transportation
  CREATE_COMMODITY_TRANSPORTATION: '/commodities/:commodityId/transportation',

  //Commodity Raw Materials
  FARMBOX_RAW_MATERIALS: '/commodities/:commodityId/raw-materials',

  //Commodity Transportation
  CREATE_COMMODITY_FUEL_AND_ENERGY: '/commodities/:commodityId/scopes',

  //Commodity Field
  CREATE_COMMODITY_FIELD: '/commodities/:commodityId/field/',

  // Commodity Distribution
  COMMODITY_DISTRIBUTION: "/commodities/:commodityId/distribution",

  // Farmbox overview
  FARMBOX_OVERVIEW: "commodities/:commodityId/overview",
  FARMBOX_APPROVAL_REPORT: "commodities/:commodityId/approval",
  DOWNLOAD_FARMBOX_APPROVAL_REPORT: "commodities/:commodityId/approval-report",

  // LiveStock Commodity
  LIVE_STOCK_COMMODITY: '/commodities/livestock',
  GROWTH_STAGE_META: '/metadata/livestock',
  GROWTH_STAGE: '/commodities/livestock/:commodityId/growth-stages',
  GET_LIVE_STOCK_COMMODITY: '/commodities/livestock/:commodityId',
  MANURE_MANAGEMENT: "/commodities/livestock/:commodityId/manure-management",
  LIVE_STOCK_COMMODITY_DISTRIBUTION: "/commodities/livestock/:commodityId/distribution",
  LIVE_STOCK_FARMBOX_OVERVIEW: "commodities/livestock/:commodityId/overview",
  FARMBOX_LIVE_STOCK_APPROVAL_REPORT: "commodities/livestock/:commodityId/approval",
  DOWNLOAD_FARMBOX_LIVE_STOCK_APPROVAL_REPORT: "commodities/livestock/:commodityId/approval-report",
  FEED_TRANSPORTATION: "commodities/livestock/:commodityId/feed",
  LIVE_STOCK_FUEL_AND_ENERGY: "commodities/livestock/:commodityId/scopes",

  // Utility Dashboard
  YOY_UTILITY_CONSUMPTION: '/dashboard/get-yoy-utility-consumption',
  MONTHLY_UTILITY_CONSUMPTION: '/dashboard/get-monthly-utility-consumption',
  UTILITY_BY_TYPE: '/dashboard/get-utility-by-type',
  UTILITY_BY_LOCATION: '/dashboard/get-utility-by-location',
  GET_UTILITY_UNIT_CONVERSION_FACTORS: '/dashboard/get-utility-unit-conversion-factors',
  CONVERT_UTILITY_UNIT_TO_GJ: '/dashboard/convert-utility-unit-to-gj',
};
